import {
    useEffect,
    useState,
} from 'react';

import {
    getFeatureFlagConfig,
    getFeatureFlagValue,
    getIsLocalStorageFeatureFlagsEnabled,
} from './FeatureFlagUtil';

export function useFeatureFlagValue<T = boolean>(featureFlagKey: string, defaultValue?: T): T | boolean {
    const isBoolean = defaultValue === undefined;
    const initialValue = isBoolean
        ? getFeatureFlagValue(featureFlagKey)
        : getFeatureFlagConfig<T>(featureFlagKey) as T || defaultValue;

    const [ value, setValue ] = useState<T | boolean>(initialValue);

    useEffect(() => {
        const updateFeatureFlagValue = (event: StorageEvent) => {
            if (event.key !== featureFlagKey) {
                return;
            }

            if (event.newValue == null) {
                if (isBoolean) {
                    setValue(getFeatureFlagValue(featureFlagKey));
                } else {
                    setValue(getFeatureFlagConfig<T>(featureFlagKey) as T || defaultValue);
                }
            } else {
                if (isBoolean) {
                    setValue(event.newValue?.toLowerCase() === 'true');
                } else {
                    setValue(event.newValue as T);
                }
            }
        };

        const isLocalFeatureFlagsEnabled = getIsLocalStorageFeatureFlagsEnabled(featureFlagKey);

        if (isLocalFeatureFlagsEnabled) {
            window.addEventListener('storage', updateFeatureFlagValue);
        }

        return () => isLocalFeatureFlagsEnabled ? window.removeEventListener('storage', updateFeatureFlagValue) : undefined;
    }, [ featureFlagKey, isBoolean, defaultValue ]);

    return value;
}
